import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import BuildFreshness from './components/BuildFreshness';
import { AuthProvider } from './AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
      {/* "A newer version is ready" — stale-tab detection (utils/buildFreshness.js). */}
      <BuildFreshness name="nventr" />
    </BrowserRouter>
  </React.StrictMode>
);
